export const AUTH_LOGIN = "AUTH_LOGIN"
export const AUTH_LOGOUT = "AUTH_LOGOUT"
export const AUTH_REQUEST = "AUTH_REQUEST"
export const AUTH_SUCCESS = "AUTH_SUCCESS"
export const AUTH_ERROR = "AUTH_ERROR"
export const AUTH_SET_HIJACK = "AUTH_SET_HIJACK"

export const USER_GET = "USER_GET"
export const USER_REGISTER = "USER_REGISTER"
export const USER_CHECK_USERNAME = "USER_CHECK_USERNAME"
export const USER_GET_PASSCODE = "USER_GET_PASSCODE"
export const USER_CONFIRM_PASSCODE = "USER_CONFIRM_PASSCODE"
export const USER_GET_EXPERIAN_QUESTIONS = "USER_GET_EXPERIAN_QUESTIONS"
export const USER_ANSWER_EXPERIAN_QUESTIONS = "USER_ANSWER_EXPERIAN_QUESTIONS"
export const USER_SET_ACCOUNT_INFO = "USER_SET_ACCOUNT_INFO"
export const USER_SETUP_BANK_ACCOUNT_INFO = "USER_SETUP_BANK_ACCOUNT_INFO"
export const USER_UPLOAD = "USER_UPLOAD"
export const USER_UPDATE = "USER_UPDATE"
export const USER_UPDATE_PASSWORD = "USER_UPDATE_PASSWORD"
export const USER_REQUEST_PASSWORD_RESET = "USER_REQUEST_PASSWORD_RESET"
export const USER_CONFIRM_PASSWORD_RESET = "USER_CONFIRM_PASSWORD_RESET"
export const USER_SET_CONTEXT = "USER_SET_CONTEXT"
export const USER_REQUEST = "USER_REQUEST"
export const USER_SUCCESS = "USER_SUCCESS"
export const USER_ERROR = "USER_ERROR"

export const ACCOUNT_GET = "ACCOUNT_GET"
export const ACCOUNT_GET_LIST = "ACCOUNT_GET_LIST"
export const ACCOUNT_EXPORT_CSV = "ACCOUNT_EXPORT_CSV"
export const ACCOUNT_VERIFY_BANK_ACCOUNT = "ACCOUNT_VERIFY_BANK_ACCOUNT"
export const ACCOUNT_REQUEST = "ACCOUNT_REQUEST"
export const ACCOUNT_SUCCESS = "ACCOUNT_SUCCESS"
export const ACCOUNT_ERROR = "ACCOUNT_ERROR"

export const LANDLORD_GET = "LANDLORD_GET"
export const LANDLORD_REQUEST = "LANDLORD_REQUEST"
export const LANDLORD_SUCCESS = "LANDLORD_SUCCESS"
export const LANDLORD_ERROR = "LANDLORD_ERROR"

export const APPLICATION_TEMPLATE_DELETE = "APPLICATION_TEMPLATE_DELETE"
export const APPLICATION_TEMPLATE_GET_LIST = "APPLICATION_TEMPLATE_GET_LIST"
export const APPLICATION_TEMPLATE_SORT_LIST = "APPLICATION_TEMPLATE_SORT_LIST"
export const APPLICATION_TEMPLATE_GET = "APPLICATION_TEMPLATE_GET"
export const APPLICATION_TEMPLATE_SUBMIT = "APPLICATION_TEMPLATE_SUBMIT"
export const APPLICATION_TEMPLATE_SHARE = "APPLICATION_TEMPLATE_SHARE"
export const APPLICATION_TEMPLATE_UPDATE_FORM = "APPLICATION_TEMPLATE_UPDATE_FORM"
export const APPLICATION_TEMPLATE_UPDATE_SETTINGS = "APPLICATION_TEMPLATE_UPDATE_SETTINGS"
export const APPLICATION_TEMPLATE_GET_SUBMITTED = "APPLICATION_TEMPLATE_GET_SUBMITTED"
export const APPLICATION_TEMPLATE_REQUEST = "APPLICATION_TEMPLATE_REQUEST"
export const APPLICATION_TEMPLATE_SUCCESS = "APPLICATION_TEMPLATE_SUCCCESS"
export const APPLICATION_TEMPLATE_ERROR = "APPLICATION_TEMPLATE_ERROR"
export const APPLICATION_TEMPLATE_SET_CURRENT_SECTION = "APPLICATION_TEMPLATE_SET_CURRENT_SECTION"
export const APPLICATION_TEMPLATE_SET_NEW = "APPLICATION_TEMPLATE_SET_NEW"
export const APPLICATION_TEMPLATE_CREATE = "APPLICATION_TEMPLATE_CREATE"
export const APPLICATION_TEMPLATE_CHECK_AVAILABLE = "APPLICATION_TEMPLATE_CHECK_AVAILABLE"
export const APPLICATION_TEMPLATE_SEARCH_ADDRESS = "APPLICATION_TEMPLATE_SEARCH_ADDRESS"
export const APPLICATION_TEMPLATE_SET_TEMPORARY = "APPLICATION_TEMPLATE_SET_TEMPORARY"

export const APPLICATION_GET_LIST = "APPLICATION_GET_LIST"
export const APPLICATION_GET = "APPLICATION_GET"
export const APPLICATION_PAY = "APPLICATION_PAY"
export const APPLICATION_BUY_REPORT = "APPLICATION_BUY_REPORT"
export const APPLICATION_SEND_PAYMENT_REQUEST = "APPLICATION_SEND_PAYMENT_REQUEST"
export const APPLICATION_PACKAGE_DOWNLOAD = "APPLICATION_PACKAGE_DOWNLOAD"
export const APPLICATION_PDF_DOWNLOAD = "APPLICATION_PDF_DOWNLOAD"
export const APPLICATION_UPDATE = "APPLICATION_UPDATE"
export const APPLICATION_GET_EXPERIAN_QUESTIONS = "APPLICATION_GET_EXPERIAN_QUESTIONS"
export const APPLICATION_ANSWER_EXPERIAN_QUESTIONS = "APPLICATION_ANSWER_EXPERIAN_QUESTIONS"
export const APPLICATION_BUY_REPORTS_BY_APPLICANT = "APPLICATION_BUY_REPORTS_BY_APPLICANT"
export const APPLICATION_GENERATE_FINICITY_CONNECT_URL = "APPLICATION_GENERATE_FINICITY_CONNECT_URL"
export const APPLICATION_SKIP_INCOME_VERIFICATION = "APPLICATION_SKIP_INCOME_VERIFICATION"
export const APPLICATION_REQUEST = "APPLICATION_REQUEST"
export const APPLICATION_SUCCESS = "APPLICATION_SUCCESS"
export const APPLICATION_ERROR = "APPLICATION_ERROR"

export const APPLICATION_BUNDLE_GET = "APPLICATION_BUNDLE_GET"
export const APPLICATION_BUNDLE_GET_LIST = "APPLICATION_BUNDLE_GET_LIST"
export const APPLICATION_BUNDLE_UPDATE = "APPLICATION_BUNDLE_UPDATE"
export const APPLICATION_BUNDLE_ARCHIVE = "APPLICATION_BUNDLE_ARCHIVE"
export const APPLICATION_BUNDLE_UNARCHIVE = "APPLICATION_BUNDLE_UNARCHIVE"
export const APPLICATION_BUNDLE_LINK = "APPLICATION_BUNDLE_LINK"
export const APPLICATION_BUNDLE_UNLINK = "APPLICATION_BUNDLE_UNLINK"
export const APPLICATION_BUNDLE_SHARE = "APPLICATION_BUNDLE_SHARE"
export const APPLICATION_BUNDLE_APPROVE = "APPLICATION_BUNDLE_APPROVE"
export const APPLICATION_BUNDLE_REJECT = "APPLICATION_BUNDLE_REJECT"
export const APPLICATION_BUNDLE_CHANGE_OWNER = "APPLICATION_BUNDLE_CHANGE_OWNER"
export const APPLICATION_BUNDLE_DELETE = "APPLICATION_BUNDLE_DELETE"
export const APPLICATION_BUNDLE_REQUEST = "APPLICATION_BUNDLE_REQUEST"
export const APPLICATION_BUNDLE_SUCCESS = "APPLICATION_BUNDLE_SUCCESS"
export const APPLICATION_BUNDLE_ERROR = "APPLICATION_BUNDLE_ERROR"
export const APPLICATION_BUNDLE_SET_SEARCH = "APPLICATION_BUNDLE_SET_SEARCH"
export const APPLICATION_BUNDLE_SET_FILTERS = "APPLICATION_BUNDLE_SET_FILTERS"
export const APPLICATION_BUNDLE_SET_STATUS = "APPLICATION_BUNDLE_SET_STATUS"

export const ATTACHMENT_UPLOAD = "ATTACHMENT_UPLOAD"
export const ATTACHMENT_DOWNLOAD = "ATTACHMENT_DOWNLOAD"
export const ATTACHMENT_REQUEST = "ATTACHMENT_REQUEST"
export const ATTACHMENT_SUCCESS = "ATTACHMENT_SUCCESS"
export const ATTACHMENT_ERROR = "ATTACHMENT_ERROR"

export const AFFILIATE_GET = "AFFILIATE_GET"
export const AFFILIATE_CHECK_NAME = "AFFILIATE_CHECK_NAME"
export const AFFILIATE_SEND_INVITE = "AFFILIATE_SEND_INVITE"
export const AFFILIATE_REQUEST = "AFFILIATE_REQUEST"
export const AFFILIATE_SUCCESS = "AFFILIATE_SUCCESS"
export const AFFILIATE_ERROR = "AFFILIATE_ERROR"
export const AFFILIATE_GET_PLAID_LINK_TOKEN = "AFFILIATE_GET_PLAID_LINK_TOKEN"
export const AFFILIATE_CREATE_BANK_ACCOUNT = "AFFILIATE_CREATE_BANK_ACCOUNT"
export const AFFILIATE_UPDATE_STRIPE_INFO = "AFFILIATE_UPDATE_STRIPE_INFO"
export const AFFILIATE_VERIFY_BANK_ACCOUNT = "AFFILIATE_VERIFY_BANK_ACCOUNT"

export const REFERRAL_GET_PENDING = "REFERRAL_GET_PENDING"
export const REFERRAL_GET_ACTIVE = "REFERRAL_GET_ACTIVE"
export const REFERRAL_REQUEST = "REFERRAL_REQUEST"
export const REFERRAL_SUCCESS = "REFERRAL_SUCCESS"
export const REFERRAL_ERROR = "REFERRAL_ERROR"

export const REPORT_GET = "REPORT_GET"
export const REPORT_SET_CURRENT = "REPORT_SET_CURRENT"
export const REPORT_GET_HTML = "REPORT_GET_HTML"
export const REPORT_PDF_DOWNLOAD = "REPORT_PDF_DOWNLOAD"
export const REPORT_FULFILL_REQUIREMENT = "REPORT_FULFILL_REQUIREMENT"
export const REPORT_SEND_ERROR_REPORT = "REPORT_SEND_ERROR_REPORT"
export const REPORT_REQUEST = "REPORT_REQUEST"
export const REPORT_SUCCESS = "REPORT_SUCCESS"
export const REPORT_ERROR = "REPORT_ERROR"

export const TRANSACTION_GET_LIST = "TRANSACTION_GET_LIST"
export const TRANSACTION_REQUEST = "TRANSACTION_REQUEST"
export const TRANSACTION_SUCCESS = "TRANSACTION_SUCCESS"
export const TRANSACTION_ERROR = "TRANSACTION_ERROR"

export const COMPANY_GET_LIST = "COMPANY_GET_LIST"
export const COMPANY_CONTACT_SALES = "COMPANY_CONTACT_SALES"
export const COMPANY_ADD_USER = "COMPANY_ADD_USER"
export const COMPANY_REMOVE_USER = "COMPANY_REMOVE_USER"
export const COMPANY_UPDATE_USER = "COMPANY_UPDATE_USER"
export const COMPANY_REQUEST = "COMPANY_REQUEST"
export const COMPANY_SUCCESS = "COMPANY_SUCCESS"
export const COMPANY_ERROR = "COMPANY_ERROR"

export const NOTIFICATION_GET_LIST = "NOTIFICATION_GET_LIST"
export const NOTIFICATION_SET_READ = "NOTIFICATION_SET_READ"
export const NOTIFICATION_REQUEST = "NOTIFICATION_REQUEST"
export const NOTIFICATION_SUCCESS = "NOTIFICATION_SUCCESS"
export const NOTIFICATION_ERROR = "NOTIFICATION_ERROR"

export const TOGGLE_CLASSIC = "TOGGLE_CLASSIC"

export const DOCUMENT_TEMPLATE_CREATE = "DOCUMENT_TEMPLATE_CREATE"
export const DOCUMENT_TEMPLATE_GET_LIST = "DOCUMENT_TEMPLATE_GET_LIST"
export const DOCUMENT_TEMPLATE_GET = "DOCUMENT_TEMPLATE_GET"
export const DOCUMENT_TEMPLATE_UPDATE = "DOCUMENT_TEMPLATE_UPDATE"
export const DOCUMENT_TEMPLATE_SEND_SIGNING = "DOCUMENT_TEMPLATE_SEND_SIGNING"
export const DOCUMENT_TEMPLATE_SET_TEMP = "DOCUMENT_TEMPLATE_SET_TEMP"
export const DOCUMENT_TEMPLATE_REQUEST = "DOCUMENT_TEMPLATE_REQUEST"
export const DOCUMENT_TEMPLATE_SUCCESS = "DOCUMENT_TEMPLATE_SUCCESS"
export const DOCUMENT_TEMPLATE_ERROR = "DOCUMENT_TEMPLATE_ERROR"

export const DOCUMENT_SIGNING_GET_LIST = "DOCUMENT_SIGNING_GET_LIST"
export const DOCUMENT_SIGNING_GET = "DOCUMENT_SIGNING_GET"
export const DOCUMENT_SIGNING_GET_BY_SIGNER = "DOCUMENT_SIGNING_GET_BY_SIGNER"
export const DOCUMENT_SIGNING_SUBMIT = "DOCUMENT_SIGNING_SUBMIT"
export const DOCUMENT_SIGNING_REQUEST = "DOCUMENT_SIGNING_REQUEST"
export const DOCUMENT_SIGNING_SUCCESS = "DOCUMENT_SIGNING_SUCCESS"
export const DOCUMENT_SIGNING_ERROR = "DOCUMENT_SIGNING_ERROR"
